var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 19.1667C8.36842 17.8475 8.26425 13.5067 10.8334 12.5C12.1967 11.9659 12.6384 14.9475 15.3126 14.2017C15.8301 14.0575 17.0484 14.7917 16.6051 15.9117M10.0001 19.1667C14.6026 19.1667 18.3334 15.4359 18.3334 10.8334C18.3334 10.2625 18.2759 9.70504 18.1667 9.16671M10.0001 19.1667C5.39758 19.1667 1.66675 15.4359 1.66675 10.8334C1.66675 6.23087 5.39758 2.50004 10.0001 2.50004C10.4117 2.50004 10.8167 2.53004 11.2126 2.58754M5.24508 3.98921C5.77092 4.37754 6.18175 4.88171 6.56925 5.53004C6.90675 6.09587 7.65758 7.67171 6.97008 8.56171C6.19175 9.56671 3.93925 9.90587 3.93925 10.8334C3.93925 11.5309 4.92675 12.3275 5.45425 13.1059C6.24758 14.2767 5.88675 15.4117 5.45425 16.1359C5.23008 16.5117 4.84841 16.8117 4.45175 17.05M17.5001 4.16671C17.5001 6.22421 14.1667 9.16671 14.1667 9.16671C14.1667 9.16671 10.8334 6.22421 10.8334 4.16671C10.8334 2.05754 12.5559 0.833374 14.1667 0.833374C15.7776 0.833374 17.5001 2.05754 17.5001 4.16671Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.872da15b.svg";
export { ForwardRef as ReactComponent };